import React from 'react'
import { Wallet, DollarSign, ArrowUpRight, Shield, Activity, BarChart3, TrendingUp } from 'lucide-react'
import { useLanguage } from '../i18n'
import AssetDashboard from '../components/AssetDashboard'

const AssetPage = ({ isConnected, userAddress }) => {
  const { t } = useLanguage()
  
  const assetStats = [
    { icon: DollarSign, value: '$2.4M', label: t('assets.totalAssets'), change: 15.2, changeLabel: t('fuel.thisMonth'), color: 'gold' },
    { icon: Activity, value: '18,472', label: t('assets.totalTransactions'), change: 12.8, changeLabel: t('assets.last7Days'), color: 'blue' },
    { icon: TrendingUp, value: '42.7%', label: t('assets.userProfit'), change: 3.2, changeLabel: t('assets.monthOverMonth'), color: 'green' },
    { icon: Shield, value: '100%', label: t('assets.fundSecurity'), change: 0, changeLabel: t('assets.guarantee'), color: 'cyan' }
  ]

  const features = [
    {
      icon: Wallet,
      title: t('assets.realtimeBalance'),
      description: t('assets.realtimeBalanceDesc')
    },
    {
      icon: DollarSign,
      title: t('assets.usdtRewardAccumulation'),
      description: t('assets.usdtRewardAccumulationDesc')
    },
    {
      icon: ArrowUpRight,
      title: t('assets.secureWithdrawal'),
      description: t('assets.secureWithdrawalDesc')
    },
    {
      icon: Shield,
      title: t('assets.fullyOnChain'),
      description: t('assets.fullyOnChainDesc')
    }
  ]

  return (
    <div className="min-h-screen py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* 页面标题 */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center space-x-2 bg-titanium-gold/10 border border-titanium-gold/30 rounded-full px-4 py-2 mb-6">
            <Wallet className="w-4 h-4 text-titanium-gold" />
            <span className="text-sm font-semibold text-titanium-gold uppercase tracking-wider">{t('assets.assetManagement')}</span>
          </div>
          <h1 className="tech-title text-5xl md:text-6xl font-bold mb-4">
            {t('assets.title')}
          </h1>
          <p className="tech-subtitle text-xl max-w-3xl mx-auto">
            {t('assets.subtitle')}
          </p>
        </div>

        {/* 资产统计 */}
        <div className="mb-12">
          <div className="tech-grid tech-grid-4">
            {assetStats.map((stat, idx) => (
              <div key={idx} className="stat-card">
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <div className="stat-value">{stat.value}</div>
                    <div className="stat-label">{stat.label}</div>
                    {stat.change !== undefined && (
                      <div className={`stat-change ${stat.change >= 0 ? 'positive' : 'negative'}`}>
                        {stat.change >= 0 ? <ArrowUpRight className="w-4 h-4" /> : <ArrowUpRight className="w-4 h-4 rotate-180" />}
                        <span>{Math.abs(stat.change)}%</span>
                        {stat.changeLabel && <span className="ml-1 opacity-70">{stat.changeLabel}</span>}
                      </div>
                    )}
                  </div>
                  <div className="icon-tech">
                    <stat.icon className="w-7 h-7" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 功能特性 */}
        <div className="mb-12">
          <div className="text-center mb-8">
            <h2 className="tech-title text-3xl font-bold mb-3">{t('assets.securityFeatures')}</h2>
            <p className="tech-subtitle text-lg">{t('assets.securityFeaturesDesc')}</p>
          </div>
          <div className="tech-grid tech-grid-2">
            {features.map((feature, idx) => (
              <div key={idx} className="glass-card p-8">
                <div className="icon-tech mb-6">
                  <feature.icon className="w-8 h-8" />
                </div>
                <h3 className="tech-title text-xl font-bold mb-3">{feature.title}</h3>
                <p className="tech-subtitle">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* 资产仪表盘 */}
        <div className="glass-card gold-border">
          <div className="p-8">
            <div className="text-center mb-8">
              <h2 className="tech-title text-3xl font-bold mb-3">{t('assets.dashboard')}</h2>
              <p className="tech-subtitle text-lg">{t('assets.dashboardDesc')}</p>
            </div>
            <AssetDashboard
              isConnected={isConnected}
              walletAddress={userAddress}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default AssetPage
